module.exports = __webpack_public_path__ + "static/henho2-5ee4fa4ed177ae67530df2f539f54230.jpg";